import { Business } from '../../store/slices/businessSlice.types'
import {
  BusinessDocument,
  UserDocument,
  WorkspaceDocument,
  WorkspaceInvitationDocument,
  WorkspaceType,
} from './db.types'
import { UserProfile } from '../../store/slices/userSlice.types'
import { Workspace, WorkspaceInvitation } from '../../store/slices/slices.types'

export const transformUser = (u: UserDocument): UserProfile => {
  return {
    email: u.email,
    name: u.name,
    selfAssessmentEnabled: u.selfAssessmentEnabled,
    signature: u.signature,
  }
}

export const transformBusiness = (
  b: BusinessDocument & { id: string },
): Business => {
  return {
    id: b.id,
    name: b.business.title,
    companyNumber: b.business.companyNumber,
    companyStatus: b.business.companyStatus,
    dateOfCreation: b.business.dateOfCreation,
    address: b.business.address,
    officers: b.business.officers.map((o) => ({
      id: o.id,
      name: o.name,
      role: o.role,
      occupation: o.occupation,
    })),
    accountingReferenceDate: b.calendar?.accountingReferenceDate,
    owner: b.owner,
    vatSettings: b.vatSettings,
  }
}

export const transformWorkspace = (
  w: WorkspaceDocument & { id: string },
): Workspace => {
  if (w.spaceType === WorkspaceType.BUSINESS) {
    return {
      id: w.id,
      name: w.name,
      owner: w.owner,
      calendarYearEndReferenceDate: w.calendar?.yearEndReferenceDate,
      spaceType: w.spaceType,
      collaborators: w.collaborators,
      business: {
        business: {
          name: w.business.business.title,
          companyNumber: w.business.business.companyNumber,
          companyStatus: w.business.business.companyStatus,
          dateOfCreation: w.business.business.dateOfCreation,
          address: w.business.business.address,
        },
        vatSettings: w.business.vatSettings,
      },
    }
  }
  return {
    id: w.id,
    name: w.name,
    owner: w.owner,
    calendarYearEndReferenceDate: w.calendar?.yearEndReferenceDate,
    collaborators: w.collaborators,
    spaceType: w.spaceType,
  }
}

export const transformWorkspaceInvitation = (
  i: WorkspaceInvitationDocument & { id: string },
): WorkspaceInvitation => {
  return {
    id: i.id,
    email: i.email,
    status: i.status,
    workspaceId: i.workspaceId,
    permissions: i.permissions,
  }
}
